import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { useAtom } from 'jotai';
import { differenceInCalendarDays } from 'date-fns';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { currentDateAtom } from '../../../Atoms';
import { culture, getPreviousDate, getNextDate } from '../../../Helpers/dates';

const DateStepper = function DateStepper() {
  const [date, setDate] = useAtom(currentDateAtom);
  const daysFromToday = differenceInCalendarDays(date, new Date());

  const handleBack = () => {
    setDate(getPreviousDate(date));
  };

  const handleNext = () => {
    setDate(getNextDate(date));
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-start",
        width: "auto",
        alignItems: "center",
        ml: "-9px",
        gap: 1.5
      }}>
      <IconButton
        size="small"
        onClick={handleBack}
        disabled={daysFromToday <= -3}
      >
        <ArrowBackIosNewIcon />
      </IconButton>
      <Typography variant="button" sx={{ color: 'greys.darker' }}>
        {new Date(date).toLocaleDateString(culture, {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
        })}
      </Typography>
      <IconButton
        size="small"
        onClick={handleNext}
        disabled={daysFromToday >= 3}
      >
        <ArrowForwardIosIcon />
      </IconButton>
    </Box>
  );
};

export default DateStepper;
